import React, { Component } from "react";
import moment from "moment";
import Modal from "../Modal/Modal";
import Input from "../Input/Input";
import Button from "../Button/Button";
import { withFirebase } from "../Firebase/Firebase";
import { withRouter } from "react-router-dom";
import VotingErrorModal from "../VotingErrorModal/VotingErrorModal";
import { validEmail } from "../../config";
import countries from "../../assets/js/countries.json";
import RichText from "../RichText/RichText";

class VotingModal extends Component {
  state = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    postCode: "",
    country: "",
    error: false,
    loading: false,
    agreed: false
  };

  handleInputEvent = (e, key) => {
    this.setState({
      [key]: e.target.value
    });
  };

  handleCheckboxEvent = (e, key) => {
    this.setState({
      [key]: !this.state[key]
    });
  };

  startVoting = async e => {
    e.preventDefault();
    if (!this.validate()) {
      return;
    }
    this.setState({
      loading: true
    });
    // Lets check if we've already voted in this competition
    const hasVoted = await this.props.methods.checkIfVotedByEmail(
      this.props.competitionId,
      this.state.emailAddress
    );
    if (!hasVoted) {
      const ipAddress = await this.getIPAddress();
      const emailHash = await this.props.methods.newVoter(
        this.props.competitionId,
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          emailAddress: this.state.emailAddress,
          postCode: this.state.postCode,
          country: this.state.country,
          agreed: this.state.agreed,
          ipAddress,
          created: moment().toISOString(),
        }
      );
      const competitionSlug = this.props.match.params.slug;
      this.props.history.push(
        `/competition/${competitionSlug}/vote/${emailHash}`
      );
    } else {
      this.setState({
        error: true,
        loading: false
      });
    }
  };

  getIPAddress = async () => {
    // Requires an external service as clientside js doesn't have access to IP Address. This could be replaced with our own cloud function
    try {
      const response = await fetch("http://ip-api.com/json");
      const json = await response.json();
      return json.query;
    } catch (error) {
      return null;
    }
  };

  validate = () => {
    return (
      this.state.firstName !== "" &&
      this.state.lastName !== "" &&
      this.state.emailAddress !== "" &&
      this.state.postCode !== "" &&
      this.state.country !== ""
    );
  };

  render() {
    const { textBody } = this.props

    return (
      <Modal handleDismiss={this.props.handleDismiss}>
        <form className="voting-modal" onSubmit={this.startVoting}>
          { textBody ? <RichText content={textBody} /> : null }
          <Input
            placeholder="First Name"
            value={this.state.firstName}
            onChange={e => this.handleInputEvent(e, "firstName")}
          />
          <Input
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={e => this.handleInputEvent(e, "lastName")}
          />
          <Input
            placeholder="Email Address"
            value={this.state.emailAddress}
            type="email"
            validate={email => validEmail.test(String(email).toLowerCase())}
            onChange={e => this.handleInputEvent(e, "emailAddress")}
          />
          <Input
            placeholder="Postcode/Zip code"
            value={this.state.postCode}
            onChange={e => this.handleInputEvent(e, "postCode")}
          />
          <Input
            styleContainer={{textAlign: 'left'}}
            value={this.state.country}
            type="dropdown"
            options={{
              "": "Select Country",
              ...countries
            }}
            onChange={e => this.handleInputEvent(e, "country")}
          />
          <Input
            title="Thanks for voting. You can go in the draw for one of twenty $100 gift vouchers, generously donated by our sponsor, Platypus Shoes. To be eligible for inclusion in the prize draw, please consent to your details being provided to Platypus Shoes."
            value={this.state.agreed}
            type="checkbox"
            onChange={e => this.handleCheckboxEvent(e, "agreed")}
          />
          <Button disabled={!this.validate() || this.state.loading}>
            {this.state.loading ? "Submitting..." : "Start Voting"}
          </Button>
        </form>
        {this.state.error && (
          <VotingErrorModal
            handleDismiss={() => {
              // Dismiss this modal and the voting modal
              this.props.handleDismiss();
            }}
          />
        )}
      </Modal>
    );
  }
}

export default withRouter(withFirebase(VotingModal));




// WEBPACK FOOTER //
// ./src/components/VotingModal/VotingModal.js